/* eslint-disable standard/array-bracket-even-spacing */
/* eslint-disable no-undef */
<template>
    <div>
     <!-- PRIVACY MODAL -->
    <privacy-modal ref="PrivacyModal"></privacy-modal>
    <!-- END PRIVACY MODAL -->
    <consent-preview @acceptConsent="acceptEtermin" v-if="consentAccepted==='0'" :cname="consentName" :consentInfo="consentInfo"></consent-preview>
    <div class="etermin-wrapper" :class="stylemodifier" v-if="consentAccepted==='1'">

        <!-- HEADLINE -->
        <div class="etermin-headline mb-6" v-if="format=='normal'">
           <h2 class="pb-1">{{ steps[cstep].title }}</h2>
           <div>{{ steps[cstep].description }}</div>
        </div>
        <!-- END HEADLINE-->

        <div class="vue-etermin-form w-100 position-relative pos" :class="classType">
            <div class="etermin-overlay-wrapper">
                <!-- ETERMIN CLOSE -->
                <etermin-close @closeApp="closeApp" class="position-absolute" v-if="format=='modal'"></etermin-close>
                <!-- ETERMIN CLOSE END -->

                <div v-if="type === 'map'" class="d-flex d-lg-none px-5 px-lg-0 align-items-center justify-content-between mb-2">
                    <h1 class="h3" id="etermin-map-headline">Termin buchen</h1>
                </div>

                <!-- STEPS NAVIGATION -->
                <div :class="{'px-5 px-lg-0': type === 'map'}">
                    <steps-navigation :steps="steps"></steps-navigation>
                </div>
                <!-- STEPS NAVIGATION END -->

                <!-- VUE PROGRESS BAR -->
                <div class="m-auto vue-progress-bar">
                    <vue-progress-bar></vue-progress-bar>
                </div>
                <!-- END VUE PROGRESS BAR -->

                <div class="etermin-app-main content p-5 bg-white border-radius-top border-l-bottom-secondary-l mt-1">

                <!-- NOTIFICATION CONTAINER -->
                <notification-container :appointement="appointement" />
                <!-- END NOTIFICATION CONTAINER -->

                    <!-- STEPS 1 START -->
                    <service-step :appointement="appointement" @getTimeSlots="getTimeSlots" v-if="cstep==0"></service-step>
                    <!-- STEPS 1 END -->

                    <!-- STEPS 2 START -->
                    <termin-step v-on:mounted="scrollToTop" :appointement="appointement" @getTimeSlots="getTimeSlots" v-if="cstep==1"></termin-step>
                    <!-- STEPS 2 END -->

                    <!-- STEPS 3 START -->
                    <daten-step v-on:mounted="scrollToTop" :appointement="appointement" :fields="form.fields" @closeApp="closeApp" @validateRequired="validateRequired" @validateSalutation="validateSalutation" @validateMail="validateMail"  @validateTelephon="validateTelephon" v-if="cstep==2" :format="format"></daten-step>
                    <!-- STEPS 3 END -->

                    <!-- STEPS 4 START -->
                    <fertig-step v-on:mounted="scrollToTop" :appointement="appointement" v-if="cstep==3"></fertig-step>
                    <!-- STEPS 4 END -->

                    <!-- VALIDATION ERROR -->
                    <div class="validation-err">
                        <p class="text-err" v-if="steps[cstep].validation.status===-1">{{ steps[cstep].validation.msg }}</p>
                    </div>
                    <!-- END VALIDATION ERROR -->

                    <!-- DATAPRIVACY MOBILE -->
                    <div class="daten-btn mob d-lg-none justify-content-center">
                        <a href="#" class="d-block final-step-button mt-1 data text-s" @click="openModal">{{ text.eTerminDataPrivacy }}</a>
                    </div>
                    <!-- END DATAPRIVACY MOBILE -->
                </div>
            <!-- footer buttons -->
            <steps-footer :type="type" :appointement="appointement" :format="format" :fields="form.fields"  @closeApp="closeApp"  @validateRequired="validateRequired" @validateSalutation="validateSalutation" @validateMail="validateMail"  @validateTelephon="validateTelephon" @openModal="openModal"></steps-footer>
            <!-- end footer buttons -->
            </div>
        </div>

     </div >
    </div>

</template>

<script>

import { mapState } from 'vuex'
import moment from 'moment'
import postscribe from 'postscribe'
import ConsentPreview from '@/components/ConsentPreview.vue'
import PrivacyModal from '@/components/Etermin/PrivacyModal.vue'
import EterminClose from '@/components/Etermin/EterminClose.vue'
import ServiceStep from '@/components/Etermin/ServiceStep.vue'
import TerminStep from '@/components/Etermin/TerminStep.vue'
import DatenStep from '@/components/Etermin/DatenStep.vue'
import FertigStep from '@/components/Etermin/FertigStep.vue'
import StepsNavigation from '@/components/Etermin/StepsNavigation.vue'
import StepsFooter from '@/components/Etermin/StepsFooter.vue'
import NotificationContainer from '@/components/NotificationContainer.vue'

moment.locale('de')
const now = new Date()

export default {
    name: 'etermin',
    components: {
        ConsentPreview,
        PrivacyModal,
        EterminClose,
        StepsNavigation,
        ServiceStep,
        TerminStep,
        DatenStep,
        FertigStep,
        StepsFooter,
        NotificationContainer
    },
    props: {
        format: {
            type: String,
            required: true
        },
        stylemodifier: {
            type: String,
            required: false
        },
        type: {
            type: String,
            required: false
        }
    },
    data () {
        return {
            cmpReady: false,
            consentAccepted: '-1',
            consentName: 'Etermin',
            consentInfo: Drupal.t('The external appointment booking service is provided by Timify. When you activate the service, personal data (encrypted) is processed and cookies are set.'),
            checkingInterval: null,
            appointement: {
                calenderid: '',
                services: [],
                date: null,
                time:null,
                contact: {
                    salutation: '',
                    firstname: '',
                    lastname: '',
                    telephone: '',
                    email: '',
                    desc: ''
                },
            },
            form: {
                fields: {
                    salutation: {
                        validation: true,
                        errmessage: ''
                    },
                    firstname: {
                        validation: true,
                        errmessage: ''
                    },
                    lastname: {
                        validation: true,
                        errmessage: ''
                    },
                    email: {
                        validation: true,
                        errmessage: '',
                        /* eslint-disable-next-line */
                        reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
                    },
                    telephone: {
                        validation: true,
                        errmessage: '',
                        /* eslint-disable-next-line */
                        reg: /(\(?([\d \-\)\–\+\/\(]+){6,}\)?([ .\-–\/]?)([\d]+))/
                    }
                },
                errMessages: {
                    fieldRequired: Drupal.t('Input required'),
                    wrongMail: Drupal.t('Please enter a valid email address.'),
                    wrongTelephone: Drupal.t('Please enter a valid phone number.')
                }
            },
            modalOpen: false,
            text: {
                eTerminDataPrivacy: Drupal.t('Timify data privacy policy')
            }
        }
    },
    watch: {
        cmpReady: function (data) {
            if (data) {
                clearInterval(this.checkingInterval)
                // eslint-disable-next-line no-undef
                var b = __cmp('getCMPData')
                if ('vendorConsents' in b) {
                    if ('c23452' in b.vendorConsents && b.vendorConsents['c23452']) {
                        this.consentAccepted = '1'
                        // PageView Traking
                        let name = this.steps[0].tracking.ga[1]
                        this.pageViewTraking(name)
                    } else {
                        this.consentAccepted = '0'
                    }
                }
            }
        },
        cstep: {
            deep: true,
            handler (cstep) {
                // PageView Traking
                let name = this.steps[cstep].tracking.ga[1]
                this.pageViewTraking(name)
                if (cstep === 1) {
                    this.getTimeSlots(this.formatDate((this.calender.date)), 0)
                }
            }
        },
        progressLoadings: {
            deep: true,
            handler (loading) {
                if (loading.status) {
                    this.$Progress.start()
                } else {
                    if (loading.error) {
                        this.$Progress.fail()
                    } else {
                        this.$Progress.finish()
                    }
                }
            }
        }
    },
    computed: {
        ...mapState({
            steps: state => state.etermin.steps,
            calender: state => state.etermin.calender
        }),
        ...mapState([
            'loading',
            'selectedStore'
        ]),
        classType () { return this.format + '-view' },
        progressLoadings () { return this.$store.state.loading },
        servicesString () {
            let services = []
            this.appointement.services.forEach(id => {
                services.push(this.$store.getters['etermin/getServiceName'](id))
            })
            return services
        },
        cstep () { return this.$store.getters['etermin/getActiveStep'] }
    },
    methods: {
        formatDate : function(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-')
        },
        scrollToTop: () => {
            let scrollElement = (document.getElementById(`etermin-map-headline`)) ?
                // for etermin form in map
                document.getElementById(`etermin-map-headline`) :
                // for etermin form on store detail
                document.getElementById(`etermin-app`)
            if (scrollElement) scrollElement.scrollIntoView({behavior: `smooth`})
        },
        acceptEtermin: function () {
            // eslint-disable-next-line no-useless-escape
            postscribe('#main-content', '<script>window.csnoreload=1<\/script>', {
                done: function () {
                    console.info('done')
                }
            })

            setTimeout(function () {
                // eslint-disable-next-line no-undef
                __cmp('setVendorConsent',
                    // eslint-disable-next-line standard/array-bracket-even-spacing
                    ['c23452', 1 ])
            }, 500)
            this.consentAccepted = '1'
        },
        closeModal: function () {
            this.modalOpen = false
            this.$refs.PrivacyModal.close()
        },
        openModal: function () {
            this.modalOpen = true
            this.$refs.PrivacyModal.open()
        },
        closeApp: function () {
            this.$store.dispatch('setStore', null)
            this.$store.dispatch('skipProceed', null)
            this.$store.dispatch('etermin/updateSteps', 0)
            this.$store.dispatch('etermin/resetCreated', null)
            this.$store.dispatch('notification/clear', null, {
                root: true
            })
            this.$destroy()
        },
        getTimeSlots: function (date, rangesearch) {
            this.$store.dispatch('startLoading', { message: Drupal.t('Getting timeslots ...') })
            this.$store.dispatch('etermin/getTimesSlots', {
                date: date,
                rangesearch: rangesearch,
                store: this.selectedStore,
                services: this.appointement.services.join()
            })
        },
        validateRequired: function (check) {
            if (this.appointement.contact[ check ] === '') {
                this.form.fields[ check ].validation = false
                this.form.fields[ check ].errmessage = this.form.errMessages.fieldRequired
                return false
            } else {
                this.form.fields[ check ].validation = true
                this.form.fields[ check ].errmessage = ''
                return true
            }
        },
        validateSalutation: function (check) {
            if (this.appointement.contact[ check ] === '') {
                this.form.fields[ check ].validation = false
                this.form.fields[ check ].errmessage = this.form.errMessages.fieldRequired
                return false
            } else {
                this.form.fields[ check ].validation = true
                this.form.fields[ check ].errmessage = ''
                return true
            }
        },
        validateMail: function (check) {
            if (this.validateRequired(check)) {
                if (!this.form.fields.email.reg.test(this.appointement.contact.email)) {
                    this.form.fields[ check ].validation = false
                    this.form.fields[ check ].errmessage = this.form.errMessages.wrongMail
                    return false
                } else {
                    this.form.fields[ check ].validation = true
                    this.form.fields[ check ].errmessage = ''
                    return true
                }
            }
        },
        validateTelephon: function (check) {
            if (this.validateRequired(check)) {
                if (!this.form.fields.telephone.reg.test(this.appointement.contact.telephone)) {
                    this.form.fields[ check ].validation = false
                    this.form.fields[ check ].errmessage = this.form.errMessages.wrongTelephone
                    return false
                } else {
                    this.form.fields[ check ].validation = true
                    this.form.fields[ check ].errmessage = ''
                    return true
                }
            }
        },
        pageViewTraking: function (name) {
            let url = '/etermin/' + name
            // Google Tag-Manager push 'virtualPageView' to dataLayer
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: `virtual_page_view`,
                    event_type: ``,
                    event_data: {
                        path: url
                    }
                })
            }
        }

    },
    created () {
        let localThis = this
        this.checkingInterval = setInterval(function () {
            // eslint-disable-next-line no-undef
            if (__cmp('consentStatus')) {
                // eslint-disable-next-line no-undef
                if (__cmp('consentStatus').consentExists) {
                    localThis.cmpReady = true
                }
            }
        }, 500)
    }
}
</script>

<style lang="css">
  .etermin-filial-search .sweet-modal.is-alert .sweet-content {
      text-align: left;
  }
</style>
